import React from "react";
import cross from "../../../assets/svg/cross-gray.svg";
import download from "../../../assets/svg/download-purple.svg";
import eye from "../../../assets/svg/eye-blue.svg";

export default function ControlBtn({ text }) {
  let styles = {};
  let additionalClassname = "";

  switch (text) {
    case "Вернуть в черновики":
      additionalClassname = "border-[#AFB7CA] text-[#5F6B88]";
      styles["img"] = cross;
      break;
    case "Выгрузить заявки":
      additionalClassname = "border-[#8F30BC] text-[#8F30BC]";
      styles["img"] = download;
      break;
    case "Опубликовать":
      additionalClassname = "border-[#0068FF] text-[#0068FF]";
      styles["img"] = eye;
      break;
  }
  return (
    <button
      className={`py-[6px] px-4 font-medium text-[15px] border rounded-lg w-52 flex items-center text-nowrap gap-2 justify-center ${additionalClassname}`}
    >
      <img src={styles.img} alt="" />
      {text}
    </button>
  );
}
